import axios from 'axios';

// 创建axios实例
const service = axios.create({
baseURL: process.env.BASE_URL, // API的base_url
timeout: 60*1000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
config => {
// 可以在这里添加请求头等信息
return config;
},
error => {
// 请求错误处理
return Promise.reject(error);
}
);

// 响应拦截器
service.interceptors.response.use(
response => {
const res = response.data;
// 根据后端返回的数据进行处理，例如返回状态码等
return res;
},
error => {
// 响应错误处理
return Promise.reject(error);
}
);

// 封装get方法
export function get(url, params) {
return service.get(url, {
params: params
});
}

// 封装post方法
export function post(url, data) {
return service.post(url, data);
}

// 封装上传文件方法
export function upload(url, formdata) {
    return service.post(url, formdata,{
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }


// WEBPACK FOOTER //
// ./src/components/api.js